import { useState, useCallback } from "react";
import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";

export const useCorporateForm = (saveEntityCallback, onSuccess) => {
  const initialState = {
    name: "",
    regNumber: "",
    country: "",
    parentId: null
  };

  const [formData, setFormData] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateField = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const resetForm = useCallback(() => {
    setFormData(initialState);
  }, [initialState]); // Add it here

  const handleSubmit = async () => {
    const { name, regNumber, country } = formData;

    // Basic Validation
    if (!name || !regNumber || !country) {
      alert("Missing Mandatory Fields");
      return;
    }

    setIsSubmitting(true);
    try {
      /**
       * 🎯 STANDARD MAPPING
       * Convert UI state to the SQL-compliant payload using your naming convention.
       */
      const payload = {
        EntityName: name,
        TaxReference: regNumber,
        EntityTypeCode: country,
        ParentEntityId: formData.parentId,
        IsPartOfStructure: true,
        IsActive: true
      };

      // Use the standard prepareForApi before sending
      const cleanPayload = GoldenSourceHelper.prepareForApi(payload);

      const result = await saveEntityCallback(cleanPayload);

      if (result) {
        resetForm();
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      console.error("Form Submission Error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    updateField,
    handleSubmit,
    isSubmitting,
    resetForm
  };
};